<form (submit)="onFormSubmit($event)">
    <dx-form #allocateCardsToMerchantForm [formData]="formData"
        [colCount]="(screen.xSmallScreenChanged | async) ? 2 : colCount" labelLocation="left"
        [screenByWidth]="getSizeQualifier" (onFieldDataChanged)="onFieldChange(null,null,$event)">
        <dxi-item dataField="merchantId" editorType="dxSelectBox" [editorOptions]="{
                            items: merchantList,
                            displayExpr: 'CompanyName',
                            valueExpr: 'Id',
                            searchEnabled: true
                        }">
            <dxo-label text="Merchant"></dxo-label>
            <dxi-validation-rule type="required" message="You must select a merchant."></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="walletId" editorType="dxSelectBox" [editorOptions]="{
                            items: walletList,
                            displayExpr: 'name',
                            valueExpr: 'id',
                            searchEnabled: true,
                            disabled: formData.merchantId < 0
                            }">
            <dxo-label text="Wallet"></dxo-label>
            <dxi-validation-rule type="required" message="You must select a wallet."></dxi-validation-rule>
        </dxi-item>

        <dxi-item>
            <dxo-label text="Number of Unallocated Cards"></dxo-label>
            <div>{{ formData.unallocatedCards }}</div>
        </dxi-item>

        <dxi-item dataField="numberOfCards" [isRequired]="true" editorType="dxNumberBox"
            [editorOptions]="{showClearButton: true,
            format : '#',
            value: formData.numberOfCards,
            valueChangeEvent: 'input',
            disabled: formData.walletId < 0, step : 0}">
            <dxo-label text="Number of Cards"></dxo-label>
            <dxi-validation-rule type="required" message="Number of cards is required."></dxi-validation-rule>
            <dxi-validation-rule type="numeric" message="Number of cards must be a number."></dxi-validation-rule>
            <dxi-validation-rule type="range" [min]="1"
                message="Number of cards must be at least 1."></dxi-validation-rule>
            <dxi-validation-rule type="range" [max]="formData.unallocatedCards"
                message="Number of cards must be less than unallocated cards."></dxi-validation-rule>
        </dxi-item>

        <dxi-item>
            <dxo-label text="Service fee"></dxo-label>
            <div>{{ formData.fee | currency:'R' }}</div>
        </dxi-item>

        <dxi-item>
            <div *dxTemplate style="text-align: right;">
                <dx-button [text]="submitButtonOptions.text!" [type]="submitButtonOptions.type!"
                    [width]="submitButtonOptions.width!" [useSubmitBehavior]="submitButtonOptions.useSubmitBehavior!"
                    [disabled]="!formValid || formData.numberOfCards <= 0 || formData.walletId <= 0">
                </dx-button>
            </div>

        </dxi-item>
    </dx-form>
</form>
